import moment from 'moment';
import { Strings } from './Strings';
import { AppConfig } from '../../AppConfig';

export class Helper {
  static inArray(arr, value) {
    if (!arr) return false
    return arr.indexOf(value) >= 0 ? true : false
  }
  static getString(key) {
    return Strings.getString(key) || key
  }
  static setLanguage(lang) {
    Strings.setLanguage(lang)
    // if (['ar'].indexOf(lang) >= 0) {
    //   I18nManager.forceRTL(true)
    // } else {
    //   I18nManager.forceRTL(false)
    // }
  }

  static getLanguage() {
    return Strings.getLanguage();
  }

  static getLanguageText(data, key) {
    const language = Strings.getLanguage();
    return data[key + '_' + language] || data[key];
  }
  static encodeQueryString = (data) => {
    const ret = [];
    for (const d in data) {
      ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
    }
    return ret.join('&');
  }
  static formatName(item) {
    let name = '';
    if (!item) {
      return name;
    }
    if (item.nametitle) {
      name += item.nametitle
      name += ' '
    }
    if (item.givenname) {
      name += item.givenname
      name += ' '
    }
    if (item.middlename) {
      name += item.middlename
      name += ' '
    }
    if (item.familyname) {
      name += item.familyname
    }
    return name;
  }
  static getErrorMsg(error) {
    let message;
    if (typeof error === 'string') {
      message = error;
    }
    if (!message) {
      if (error) {
        if (error.original && error.original.bodyJson) {
          const body = error.original.bodyJson;
          if (body && body.code && body.message) {
            message = body.message;
          }
        }
        if (!message) {
          message = error.message;
        }
        if (!message) {
          message = error.description;
        }
      }
    }
    return message || 'An error occurred. Contact customer care team if the problem persists';
  }
  static showProgressModal(caller) {
    caller.setState({ progressModelOpen: true });
  }
  static hideProgressModal(caller) {
    caller.setState({ progressModelOpen: false });
  }
  static formatTimestamp(utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('Do MMM YYYY, h:mm a');
  }
  static formatDate(utcTimestamp) {
    return moment.utc(utcTimestamp).local().format('Do MMM YYYY');
  }
  static populateFormDefinitionValues(formDefinition, values) {
    for (const field of formDefinition.steps[0].fields) {
      if (values.__STAGED && field.key in values.__STAGED) {
        field.pendingApproval = true
        Helper.assignFieldValue(field, values.__STAGED)
      } else if (field.key in values) {
        Helper.assignFieldValue(field, values)
      } else {
        delete field.value;
        delete field.link;
      }
    }
  }
  static assignFieldValue(field, values) {
    field.value = values[field.key]
    if (field.type === 'radio' && Array.isArray(field.value)) {
      if (field.value.length > 0) {
        field.value = field.value[0]
      } else {
        delete field.value
      }
    }
    if (field.linkName) {
      field.link = values[field.linkName]
    }
  }
  static deleteFormDefinitionValues(formDefinition) {
    for (const field of formDefinition.steps[0].fields) {
      delete field.value;
      if (field.imageUpload === true) {
        field.link = null;
      }
    }
  }
  static validateAndFormatEmail(email) {
    const result = email.replace(/\s/g, '')
    if (!/\S+@\S+\.\S+/.test(result)) {
      throw new Error('Invalid email');
    }
    return result.toLowerCase()
  }
  static formatCurrency(value) {
    return Helper.getLanguage() === 'ar'
      ? AppConfig.DefaultCurrency + ' ' + Number(value / 100)
      : Number(value / 100) + ' ' + AppConfig.DefaultCurrency;
  }
  static dictToArray(dict) {
    const arr = []
    if (!dict) {
      return arr
    }
    Object.keys(dict).forEach(k => {
      arr.push(dict[k])
    })
    return arr
  }
  static sortDictArray(docs) {
    return docs.sort((a, b) => {
      if (!a.order) {
        return -1
      }
      if (!b.order) {
        return 1
      }
      return a.order.localeCompare(b.order)
    })
  }
  static sortDictArrayRev(docs) {
    return docs.sort((a, b) => {
      if (!a.order) {
        return 1
      }
      if (!b.order) {
        return -1
      }
      return b.order.localeCompare(a.order)
    })
  }

  static calculateAgeOld(ts) {
    const today = new Date();
    const birthDate = new Date(ts);
    let age = today.getFullYear() - birthDate.getFullYear();
    if(age < AppConfig.AGE_LOWER_LIMIT || age > AppConfig.AGE_LOWER_LIMIT) {
      return age
    }

    if(age === AppConfig.AGE_LOWER_LIMIT) {
      const m = today.getMonth() - birthDate.getMonth();
      if(m < 0) {
        age = age - 1
        return age;
      }
      if (m === 0) {
        if (today.getDate() < birthDate.getDate()) {
          age = age - 1
          return age
        } else {
          return age
        }
      }
      if(m > 0) {
        return age
      }
    }
  }

  static calculateAge(ts) {
    const birthDate = moment(ts)
    const yB = Number(moment(birthDate).format('YYYY'))
    const mB = Number(moment(birthDate).format('M'))
    const dB = Number(moment(birthDate).format('D'))
    const tsB = Number(moment(birthDate).valueOf())

    const today = moment()
    const yT = Number(moment(today).format('YYYY'))
    const mT = Number(moment(today).format('M'))
    const dT = Number(moment(today).format('D'))
    const tsT = Number(moment(today).valueOf())

    let age = yT - yB

    if(age !== AppConfig.AGE_LOWER_LIMIT && age !== AppConfig.AGE_UPPER_LIMIT) {
      return age
    }

    if(age === AppConfig.AGE_LOWER_LIMIT) {
      const m = mT - mB
      if(m < 0) {
        age = age - 1
        return age;
      }
      if (m === 0) {
        if (dT < dB) {
          age = age - 1
          return age
        } else {
          return age
        }
      }
      if(m > 0) {
        return age
      }
    }

    if(age === AppConfig.AGE_UPPER_LIMIT) {
      const m = mT - mB
      if(m < 0) {
        age = age - 1
        return age;
      }
      if (m === 0) {
        if (dT < dB) {
          age = age - 1
          return age
        } else {
          return age
        }
      }
      if(m > 0) {
        return age
      }
    }
  }

  static validateAndFormatEmailV2(email) {
    const result = email.replace(/\s/g, '')
    if (!/\S+@\S+\.\S+/.test(result)) {
      return false
    }
    return result.toLowerCase()
  }

  static removeNullValues(dict) {
    for(const key  in dict) {
      if(dict[key] === undefined || dict[key] === null) {
        delete dict[key]
      }
    }
    return dict
  }
}



// WEBPACK FOOTER //
// ./src/common/helpers/Helper.js